import { Tag, TagColor } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsAccountMembershipStatusEnum } from 'generated/resources/graphql'
import i18n from 'modules/core/lib/i18n'

export const statusTagColor: Record<BankingValueObjectsAccountMembershipStatusEnum, TagColor> = {
  pending_consent: Tag.Types.purple,
  invitation_sent: Tag.Types.champagne,
  enabled: Tag.Types.lime,
  disabled: Tag.Types.radical,
}

export const statusTagLabel = (status: BankingValueObjectsAccountMembershipStatusEnum): string => {
  switch (status) {
    case 'pending_consent':
      return i18n.t('banking.account_memberships.status.pending_consent')
    case 'invitation_sent':
      return i18n.t('banking.account_memberships.status.invitation_sent')
    case 'enabled':
      return i18n.t('banking.account_memberships.status.enabled')
    case 'disabled':
      return i18n.t('banking.account_memberships.status.disabled')
  }
}
